/**
 * Navigation helpers that work with BrowserRouter (H5) and HashRouter (App).
 */

function navigate(path) {
    if (!path) {
        return;
    }
    if (path.startsWith('http://') || path.startsWith('https://')) {
        window.location.href = path;
        return;
    }
    const normalized = path.startsWith('/') ? path : '/' + path;
    // HashRouter uses #/; BrowserRouter uses path
    if (window.location.hash && window.location.hash.indexOf('#/') === 0) {
        window.location.hash = '#' + normalized;
        return;
    }
    // Capacitor / file protocol often needs hash routing
    if (window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform()) {
        window.location.hash = '#' + normalized;
        return;
    }
    window.location.href = normalized;
}

export const navigate_to = navigate;
